import { render, staticRenderFns } from "./account-management-detail.vue?vue&type=template&id=59ec9f3b&scoped=true"
import script from "./account-management-detail.vue?vue&type=script&lang=js"
export * from "./account-management-detail.vue?vue&type=script&lang=js"
import style0 from "./account-management-detail.vue?vue&type=style&index=0&id=59ec9f3b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ec9f3b",
  null
  
)

export default component.exports